import { LuWallet } from 'react-icons/lu';

import type { NavItem } from 'src/shared/components/shell/navTypes';

export const financeNav: NavItem[] = [
  {
    icon: LuWallet,
    label: 'Finanzas',
    hint: 'Caja, gastos y resultado',
    to: '/finanzas',
    placement: 'more',
    // The first entry in this menu that is not for everyone. Mirrors
    // `RESOURCE_ROLES["finance:read"]`: collecting on your own appointment is
    // the job, reading the whole till is not.
    roles: ['owner', 'manager'],
  },
];
